import { Component, OnInit } from '@angular/core';


@Component({
  selector: 'app-academic-nodata-found',
  templateUrl: './academic-nodata-found.component.html',
  styleUrls: ['./academic-nodata-found.component.scss']
})
export class AcademicNodataFoundComponent implements OnInit{
  constructor(){}
  ngOnInit(): void {
   
  }

}
